import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import { useNavigate } from "react-router-dom";
import { CloseOutlined } from "@ant-design/icons";
// Components
import { Form, Select, Row, Col, Flex, message, Space } from "antd";
import StepsHeading from "./StepsHeading";
import { CustomInput, AddItemButton, CustomTitle, CustomSelect } from "../../../components";
import { AddProducts, GetProducts, GetProductTypes } from "../../../api's/onboarding.js";
import { useSpin } from "../../../components/SpinContext.js";
import useToken from '../../../common/helper/usetoken';
import { stageOfDevelopmentValueList } from "../../../common/static_data.js";
import useSelection from "antd/es/table/hooks/useSelection.js";
import { selectProductTypeState } from "../../../reudx-toolkit/slice/ProductTypeSlice.js";
import { useSelector, useDispatch } from "react-redux";
import { fetchAllProducts } from "../../../reudx-toolkit/slice/ProductSlice.js";

const { Option } = Select;

const customStyle = {
  height: "36px",
  width: "100%",
  backgroundColor: "#F3F3F3",
  color: "#5E5E5E",
  borderRadius: "8px",
  lineHeight: "38px",
  boxShadow: "none",
  height: "36px",
  border: "0px"
}

const placeholderStyle = {
  "::placeholder": {
    color: "#5E5E5E",
  }
}

const Products = forwardRef(({ onNext, onSuccess }, ref) => {
  const { showSpin, hideSpin } = useSpin();
  const [productForm] = Form.useForm();
  const [forms, setForms] = useState([{}]);
  const { token, removeToken } = useToken();
  const navigate = useNavigate();
  const [productTypeList, setProductTypeList] = useState();
  const state = useSelector((state)=>state);
  const dispatch = useDispatch();
  const [requestStatus,setRequestStatus] =useState(null);

  const [data, setData] = useState([
    { key: "1", email: "", permission: "View only" },
    { key: "2", email: "", permission: "View only" },
    { key: "3", email: "", permission: "View only" },
  ]);


  const fetchProductLists = () => {
    showSpin();
    GetProductTypes(token)
      .then((res) => {
        const data = res?.data ? res.data : null;
        if (data) {
          if (data?.data?.is_success) {
            let res = data.data.data;
            if (res) {
              setProductTypeList(res);
            }
          } else {
            message.error(data?.data?.message);
          }
        }
      })
      .catch((error) => {
        unauthorize(error)
      }).finally(() => {
        hideSpin();
      });

  }

  useEffect(() => {
    if(state){
      setRequestStatus(state?.status ? state.status : null)
      // if(state?.ProductTypes?.productTypeList?.length>0){
      //   setProductTypeList(state?.ProductTypes?.productTypeList)
      // }
    }
  }, [state]);
  useEffect(() => {
    fetchProductLists()
  }, [])
  

  //Api call for fetching products
  // const fetchProducts = () => {
  //   showSpin();
  //   GetProducts(token)
  //     .then((res) => {
  //       const data = res?.data || null;
  //       if (data) {
  //         if (data.data?.is_success) {
  //           if (data.data.data && data.data.data.length > 0) {
  //             productForm.setFieldsValue({
  //               productList: data.data.data, // 'users' is the name of the Form.List
  //             });
  //             // message.success(data?.data?.message);
  //           }
  //         } else {
  //           message.error(data?.data?.message);
  //         }
  //       }
  //     })
  //     .catch((error) => {
  //       unauthorize(error);
  //     }).finally(() => {
  //       hideSpin();
  //     });

  // };

  // useEffect(() => {
  //   fetchProducts();
  // }, []);

  useEffect(()=>{
      if(dispatch){
        dispatch(fetchAllProducts(token))
      }
    },[dispatch]);
  
    //setting data from store
    useEffect(()=>{
      if(state){
        setRequestStatus(state?.status ? state.status : null)
      if(state?.Products?.productList.length>0){
        productForm.setFieldsValue({
            productList: state?.Products?.productList, // 'users' is the name of the Form.List
        });
      }
    }
    },[state]);

     //if status is unauthorize
      useEffect(()=>{
        if(requestStatus){
          unauthorize(requestStatus);
        }
      },[requestStatus])
       
      const unauthorize = (status) => {
        if (status === 401) {
          removeToken();
          navigate("/login");
        }
      }





  const tempratureRangeList = [
    { value: "custom", label: "Custom", min: null, max: null },
    { value: "none", label: "None", min: null, max: null },
    { value: "cryogenic", label: "-150°C to -180°C (Cryogenic)", min: -180, max: -150 },
    { value: "ultra_low_freezer", label: "-60°C to -90°C (Ultra low freezer)", min: -90, max: -60 },
    { value: "deep_frozen", label: "-40°C to -20°C (Deep frozen)", min: -40, max: -20 },
    { value: "frozen", label: "-25°C to -15°C (Frozen)", min: -25, max: -15 },
    { value: "refrigerated", label: "2°C to 8°C (Refrigerated)", min: 2, max: 8 },
    { value: "crt", label: "15°C to 25°C (CRT)", min: 15, max: 25 },
    { value: "ambient", label: "15°C to 30°C (Ambient)", min: 15, max: 30 }
  ];

  // const productTypeList = [
  //   { value: "Vaccines (non-mRNA)", label: "Vaccines (non-mRNA)" },
  //   { value: "Vaccines (mRNA)", label: "Vaccines (mRNA)" },
  //   { value: "Test Kits and Diagnostic Materials", label: "Test Kits and Diagnostic Materials" },
  //   { value: "Clinical Trial Materials", label: "Clinical Trial Materials" },
  //   { value: "Biologics (incl. Cell & Gene Therapy)", label: "Biologics (incl. Cell & Gene Therapy)" },
  //   { value: "Blood and Plasma Products", label: "Blood and Plasma Products" },
  //   { value: "Organs, Tissues, and IVF Materials", label: "Organs, Tissues, and IVF Materials" },
  //   { value: "Specialty Pharmaceuticals", label: "Specialty Pharmaceuticals" },
  //   { value: "Radiopharmaceuticals", label: "Radiopharmaceuticals" },
  //   { value: "Controlled Substances", label: "Controlled Substances" },
  //   { value: "Cold Chain APIs", label: "Cold Chain APIs" },
  //   { value: "Finished Pharmaceuticals", label: "Finished Pharmaceuticals" },
  //   { value: "Other", label: "Other" }
  // ];

  const commercialValueList = [
    { value: "$0-$10k", label: "$0-$10k" },
    { value: "$10k-$50k", label: "$10k-$50k" },
    { value: "$50k-$250k", label: "$50k-$250k" },
    { value: "$250k+", label: "$250k+" }
  ]

  const handleTemperatureRangeChange = (value, ind) => {
    if (value) {
      let obj = tempratureRangeList.find(x => x.value === value);
      if (obj) {
        if (value === "custom") {
          updateForm(ind, obj, true)
        } else {
          updateForm(ind, obj, false)
        }
      }
    }
  };

  // const unauthorize = (error) => {
  //   if (error && error?.status === 401) {
  //     removeToken();
  //     navigate("/login");
  //   }
  // }

  const handleSelectChange = (key, value) => {
    setData((prev) =>
      prev.map((item) =>
        item.key === key ? { ...item, permission: value } : item
      )
    );
  };

  const submitProducts = (model) => {
    AddProducts(token, model)
      .then((res) => {
        const data = res?.data || null;
        if (data) {
          if (data?.data?.is_success) {
          dispatch(fetchAllProducts(token));
          onSuccess();
            //message.success(data?.data?.message);
          } else {
            message.error(data?.data?.message);
          }
        }
      })
      .catch((error) => {
        unauthorize(error);
      }).finally(() => {
        hideSpin();
      });
  }

  const updateForm = (index, obj, temp_range_is_custom) => {
    if (index >= 0 && obj) {
      const list = productForm.getFieldValue('productList');
      if (list && list[index]) {
        const updatedList = [...list];
        updatedList[index] = { ...updatedList[index], temp_range_is_custom: temp_range_is_custom, temperature_min: obj?.min, temperature_max: obj?.max };
        productForm.setFieldsValue({ productList: updatedList });
        setForms(updatedList);
      }
    }
  }

  const completeStep = () => {
    productForm.validateFields().then(values => {
      if (values && values?.productList?.length > 0) {
        values.productList.forEach(element => {
          if(element){
            element.viability_window =  !element?.viability_window  ? null : element?.viability_window
          }
          
        });

        submitProducts(values.productList);
      }
    }).catch(err => {
    })
  }

  // Expose specific methods to the parent through useImperativeHandle
  useImperativeHandle(ref, () => ({
    completeStep,  // Expose the submitProducts method to the parent
  }));

  const handleisCommercial = (index) => {
    if (index >= 0) {
      const list = productForm.getFieldValue('productList');
      if (list && list[index]) {
        const updatedList = [...list];
        updatedList[index] = { ...updatedList[index], is_commercial: updatedList[index].stage_of_development === "Commercial" };
        productForm.setFieldsValue({ productList: updatedList });
        setForms(updatedList);
      }
    }

  }



  const onFinish = (values) => {
    // if (customRange) {
    //   const { custom_min, custom_max } = values;
    //   if (custom_min === undefined || custom_max === undefined) {
    //     return alert("Please specify the full custom temperature range.");
    //   }
    // }
    // console.log("Product Info:", values);
  };

  const handleAddItem = () => {
    setForms([...forms, {}]);
  };

  return (
    <>
      <div style={{ paddingBottom: "25px" }}>
        <div className="large-steps-content">
          <StepsHeading
            heading="Tell us about the products you’re shipping"
            text="Let us know the specifications of what you’re shipping so we know when to alert you of temperature excursions and viability risks."
          />

          <Flex vertical={true}  gap="24px">

            <Form form={productForm} name="validateOnly" layout="vertical" onFinish={onFinish}>
              <div className="product-shipment">
                <Form.List
                  name="productList"  // Ensure name is provided for the list
                  initialValue={[{ name: "", product_type: "", commercial_value: "", temperature_range: "", viability_window: null, temperature_min: "", temperature_max: "", temp_range_is_custom: false, temperature_unit: "C", is_commercial: false }]}  // Initial single entry
                >
                  {(fields, { add, remove }) => (
                    <Row>
                      <Row style={{ gap: "16px",width:"100%" }}>
                        <>
                          {fields.map((field, index) => (
                            <>
                            <div style={{ borderRadius: "12px",width:"100%", border: "2px solid #EEE",padding: "13px 20px 32px 20px"}}>
                              <Row gutter={[24, 16]}  key={index}>

                                <Col span={24} style={{ display: 'flex', justifyContent: "end", alignItems: "center" }}><CloseOutlined onClick={() => remove(index)} /></Col>
                                <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
                                  <Form.Item
                                    label="Product name"
                                    name={[index, "name"]}
                                    rules={[{ required: true, message: "Please enter product name" }]}
                                    style={{ marginBottom: "0" }}
                                  >
                                    <CustomInput
                                      placeholder="e.g. Pluvicto"
                                      height="36px"
                                      border="0px"
                                      bgColor="#F3F3F3"
                                      textColor="#5E5E5E"
                                      borderRadius="8px"
                                      placeholderColor="#5E5E5E"
                                      lineHeight="38px"
                                    />
                                  </Form.Item>
                                </Col>

                                <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
                                  <Form.Item
                                    label="Product type"
                                    name={[index, "product_type"]}
                                    style={{ marginBottom: "0" }}
                                    rules={[{ required: true, message: "Please select one" }]}
                                  >
                                    <Select value="" placeholder="Select"
                                      style={{ ...customStyle, ...placeholderStyle }}

                                    >
                                      {productTypeList && productTypeList.map((option, index) => (
                                        <Option key={index} value={option.id}>
                                          {option.name}
                                        </Option>
                                      ))}
                                    </Select>
                                  </Form.Item>
                                </Col>

                                <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
                                  <Form.Item
                                    label="Stage of development"
                                    name={[index, "stage_of_development"]}
                                    style={{ marginBottom: "0" }}
                                  >
                                    <CustomSelect
                                      value={"Admin"}
                                      placeholder="Select"
                                      width="100%"
                                      height="36px"
                                      border="0px"
                                      bgColor="#F3F3F3"
                                      textColor="#5E5E5E"
                                      borderRadius="8px"
                                      onChange={() => handleisCommercial(index)}
                                      options={stageOfDevelopmentValueList}
                                    />
                                  </Form.Item>
                                </Col>
                                {productForm.getFieldValue(['productList', index, 'is_commercial']) && (
                                  <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
                                    <Form.Item
                                      label="Commercial value"
                                      name={[index, "commercial_value"]}
                                      rules={[{ required: true, message: "Please enter the commercial value" }]}
                                      style={{ marginBottom: "0" }}
                                    >
                                      <CustomSelect
                                        value={"Admin"}
                                        placeholder="Select"
                                        onChange={(value) => handleSelectChange(value)}
                                        width="100%"
                                        height="36px"
                                        border="0px"
                                        bgColor="#F3F3F3"
                                        textColor="#5E5E5E"
                                        borderRadius="8px"
                                        options={commercialValueList}
                                      />
                                    </Form.Item>
                                  </Col>
                                )}
                              </Row>
                              <Row gutter={[24, 16]} style={{marginTop:"20px"}}>
                                <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
                                  <Form.Item
                                    label="Project ID"
                                    name={[index, "project_id"]}
                                    style={{ marginBottom: "0" }}
                                  >
                                    <CustomInput
                                      placeholder="Enter project id"
                                      height="36px"
                                      border="0px"
                                      bgColor="#F3F3F3"
                                      textColor="#5E5E5E"
                                      borderRadius="8px"
                                      placeholderColor="#5E5E5E"
                                      lineHeight="38px"
                                    />
                                  </Form.Item>
                                </Col>
                                <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
                                  <Form.Item
                                    label="Transit viability window"
                                    name={[index, "viability_window"]}
                                    rules={[
                                      {
                                        required: false,
                                        message: "Please enter viability window!",
                                      },
                                      {
                                        pattern: /^\d{1,5}$/,
                                        message: "Enter up to 5 digits only!",
                                      },
                                    ]}
                                    style={{ marginBottom: "0" }}
                                  >
                                    <CustomInput
                                      placeholder="5"
                                      height="36px"
                                      border="0px"
                                      bgColor="#F3F3F3"
                                      textColor={"#5E5E5E"}
                                      borderRadius="8px"
                                      placeholderColor="#5E5E5E"
                                      lineHeight="38px"
                                      suffix="hr"
                                    />
                                  </Form.Item>
                                </Col>


                                <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
                                  <Form.Item
                                    label="Temperature Range"
                                    name={[index, "temperature_range"]}
                                    rules={[{ required: true, message: "Please select a temperature range" }]}
                                    style={{ marginBottom: "0" }}
                                  >
                                    <CustomSelect
                                      value="None"
                                      placeholder="Select"
                                      onChange={(option) => handleTemperatureRangeChange(option, index)}
                                      width="100%"
                                      height="36px"
                                      border="0px"
                                      bgColor="#F3F3F3"
                                      textColor="#5E5E5E"
                                      borderRadius="8px"
                                      options={tempratureRangeList}
                                    />
                                  </Form.Item>
                                </Col>
                                {productForm.getFieldValue(['productList', index, 'temp_range_is_custom']) &&
                                  <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
                                    <Form.Item label="Custom Temperature Range"
                                      style={{ marginBottom: "0" }}>
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "8px",
                                        }}
                                      >
                                        {/* Minimum Temperature Input */}
                                        <Form.Item
                                          name={[index, "temperature_min"]}
                                          noStyle
                                          rules={[
                                            {
                                              required: true,
                                              message: "Please specify a minimum value",
                                            },
                                          ]}
                                          style={{ marginBottom: "0" }}
                                        >
                                          <CustomInput
                                            placeholder="0"
                                            height="36px"
                                            border="0px"
                                            bgColor="#F3F3F3"
                                            textColor="#5E5E5E"
                                            borderRadius="8px"
                                            width="50px"
                                            placeholderColor="#5E5E5E"
                                            lineHeight="38px"
                                          />
                                        </Form.Item>

                                        <CustomTitle
                                          text="to"
                                          fontSize="14px"
                                          fontWeight="500"
                                          color="#000"
                                          marginBottom={0}
                                        />

                                        {/* Maximum Temperature Input */}
                                        <Form.Item
                                          name={[index, "temperature_max"]}
                                          noStyle
                                          rules={[
                                            {
                                              required: true,
                                              message: "Please specify a maximum value",
                                            },
                                          ]}
                                          style={{ marginBottom: "0" }}
                                        >
                                          <CustomInput
                                            placeholder="100"
                                            height="36px"
                                            border="0px"
                                            bgColor="#F3F3F3"
                                            textColor="#5E5E5E"
                                            borderRadius="8px"
                                            width="50px"
                                            placeholderColor="#5E5E5E"
                                            lineHeight="38px"
                                          />
                                        </Form.Item>

                                        {/* Dropdown for Unit Selection */}
                                        <Form.Item
                                          // name={`custom_unit_${index}`}
                                          name={[index, "temperature_unit"]}
                                          noStyle
                                          initialValue="C"
                                          rules={[
                                            { required: true, message: "Please select a unit" },
                                          ]}
                                          style={{ marginBottom: "0" }}
                                        >
                                          <Select
                                            style={{
                                              width: "80px",
                                              borderRadius: "8px",
                                              backgroundColor: "#F3F3F3",
                                            }}
                                            options={[
                                              { value: "C", label: "°C" },
                                              { value: "F", label: "°F" },
                                            ]}
                                          />
                                        </Form.Item>
                                      </div>
                                    </Form.Item>
                                  </Col>
                                }
                               
                              </Row>
                              </div>
                            </>
                          ))}
                        </>
                      </Row>

                      <Col span={18} offset={0} className="info-div-add remove-margin-xs">
                        {/* Hide this button if you want to prevent adding new items */}
                        <AddItemButton text="Add Another" onClick={() => add()} />
                      </Col>
                    </Row>
                  )}
                </Form.List>
              </div>
            </Form>


          </Flex>
        </div>


      </div>
    </>
  );
});

export default Products;